<div class="layout-topbar">
  <a class="app-logo" routerLink="/">
    <!--<img alt="app logo" [src]="logo">-->
    <p-avatar image="{{logo}}" shape="circle" styleClass="border-2 surface-border mr-2" size="xlarge"></p-avatar>
    <span class="app-name">{{'title'|translate}}</span>
  </a>
  
  <span class=" ml-3" (click)="onMenuButtonClick()">
    <i class="cursor-pointer pi pi-align-justify text-2xl"></i>
  </span>
  
  <ul class="topbar-menu">
    <li *ngFor="let item of tabs; let i = index">
      <a [routerLink]="item.routerLink" routerLinkActive="active-route" [routerLinkActiveOptions]="item.routerLinkActiveOptions||{paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored'}"
         [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling" [preserveFragment]="item.preserveFragment!"
         [skipLocationChange]="item.skipLocationChange!" [replaceUrl]="item.replaceUrl!" [state]="item.state" [queryParams]="item.queryParams">
        <span>{{item.label}}</span>
      </a>
      <i class="pi pi-times" (click)="removeTab($event, item, i)"></i>
    </li>
    <li *ngIf="!tabs || tabs.length === 0" class="topbar-menu-empty">
    </li>
  </ul>
  
  <!--<div class="topbar-search" [ngClass]="{'topbar-search-active': searchActive}">
    <button class="topbar-searchbutton p-link" type="button" (click)="activateSearch()">
      <i class="pi pi-search"></i>
    </button>
    
    <div class="search-input-wrapper">
            <span class="p-input-icon-right">
                <input #searchinput type="text" pInputText placeholder="Search" (blur)="deactivateSearch()" (keydown.escape)="deactivateSearch()"/>
                <i class="pi pi-search"></i>
            </span>
    </div>
  </div>-->
  
  <div class="topbar-search mr-5">
    <button class="topbar-searchbutton p-link" type="button" (click)="openMessage()">
      <i class="pi pi-envelope" style="font-size: 1.5rem" pBadge value="{{unreadMessage.length}}"></i>
    </button>
  </div>
  
  <div class="topbar-profile">
    <button class="topbar-profile-button p-link" type="button" pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
      <div class="mr-3">
        <p-avatar image="{{userInfo.userAvatar}}" shape="circle" styleClass="border-2 surface-border avatar-box-shadow" size="xlarge"></p-avatar>
      </div>
      <span class="profile-details">
        <span class="profile-name" *ngIf="userInfo">{{userInfo.nickName}}</span>
        <span class="profile-name text-grey" *ngIf="company">{{company}}</span>
      </span>
      <i class="pi pi-angle-down"></i>
    </button>
    <ul class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-full sm:w-12rem mt-2 right-0 top-auto">
      <li>
        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer" (click)="setting()">
          <i class="pi pi-cog mr-3"></i>
          <span>{{'topBar.setting'|translate}}</span>
        </a>
        <a pRipple class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer" (click)="logout()">
          <i class="pi pi-power-off mr-3"></i>
          <span>{{'topBar.logout'|translate}}</span>
        </a>
      </li>
    </ul>
  </div>
</div>

<p-dialog header="最近10条消息" [(visible)]="showMessage" [modal]="true" showEffect="fade" [style]="{width: '50vw',height: '90vh'}">
  <div class="flex flex-column h-full">
    <div class="flex-auto">
      <p-timeline [value]="messageList" styleClass="customized-timeline mb-3">
        <ng-template pTemplate="marker" let-message>
          <ng-container *ngIf="message.catalog==='demand'">
            <span class="flex z-1 w-2rem h-2rem align-items-center justify-content-center text-white border-circle shadow-2" [style.backgroundColor]="'#C5E4F6'">
              <i class="iconfont iconfont-caigoudingdan text-2xl" style="color: #0B8BCC"></i>
            </span>
          </ng-container>
          <ng-container *ngIf="message.catalog==='supply'">
            <span class="flex z-1 w-2rem h-2rem align-items-center justify-content-center text-white border-circle shadow-2" [style.backgroundColor]="'#CCEBE1'">
              <i class="pi pi-shopping-cart text-2xl" style="color : #5BAD88"></i>
            </span>
          </ng-container>
          <ng-container *ngIf="message.catalog==='system'">
            <span class="flex z-1 w-2rem h-2rem align-items-center justify-content-center text-white border-circle shadow-2" [style.backgroundColor]="'#FEF1C4'">
              <i class="iconfont iconfont--qingwa text-2xl" style="color : #F7C908"></i>
            </span>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="content" let-message>
          <div class="message-item">
            <div class="flex flex-row justify-content-between">
              <div>
                {{message.title}}
              </div>
              <div class="text-grey text-xs">
                {{message.createTime}}
              </div>
            </div>
            <div class="flex flex-row pt-3 align-items-center">
              <div>
                <my-avatar image="{{message.userAvatar}}" shape="circle" styleClass="border-2 surface-border mr-3" size="xlarge" tooltipText="{{message.userName}}"></my-avatar>
              </div>
              <div class="text-lg">
                {{message.content}}
              </div>
            </div>
          </div>
        </ng-template>
      </p-timeline>
    </div>
    <div class="text-right p-3" style="position: sticky;bottom: 0;background-color: white">
      <span class="text-blue-500 hover:underline cursor-pointer block font-bold pr-3 pb-3" (click)="navigateToMessage()">
        查看全部 >>
      </span>
    </div>
  </div>
</p-dialog>
